import { render, staticRenderFns } from "./PortalStyle.vue?vue&type=template&id=efca00d6&"
import script from "./PortalStyle.vue?vue&type=script&lang=js&"
export * from "./PortalStyle.vue?vue&type=script&lang=js&"
import style0 from "./PortalStyle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports